<lib-button
  [ngSwitch]="signedIn"
  [theme]="theme"
  [fullWidth]="fullWidth"
  [centered]="centered"
  [prefixIcon]="prefixIcon"
  [badgeText]="badgeText"
  [badgeClass]="badgeClass"
  [disabled]="disabled || toggle.working"
  (buttonClick)="onMipButtonClick()"
>
  <span *ngSwitchCase="true">{{ signedInText }}</span>
  <span *ngSwitchCase="false">{{ signedOutText }}</span>
</lib-button>
<app-mip-modal
  [open]="toggle.mipModal"
  (onClose)="toggle.mipModal = false"
  (onSuccess)="updateUser()"
></app-mip-modal>